import {
  Component,
  inject,
  OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';

import {CommissionReconciliationFilter} from '../../models/commission-reconciliation';
import {

  NonNullableFormBuilder,

} from '@angular/forms';
import {
  CommissionReconciliationForm,
  CommissionReconciliationFormValues,
  DEFAULT_PROCESSORS,
  MAX_ADX_REFERENCE_LENGTH,
  MAX_CONFIRMATION_NUMBER_LENGTH,
  MAX_FILE_NAME_LENGTH,
} from '../../constants/commission-reconciliation-filter';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import moment from 'moment';

@Component({
    selector: 'app-commission-reconciliation-filter',
    templateUrl: './commission-reconciliation-filter.component.html',
    styleUrl: './commission-reconciliation-filter.component.scss',
    standalone: false
})
export class CommissionReconciliationFilterComponent implements OnInit {
  private readonly dialogRef = inject<
    MatDialogRef<
      CommissionReconciliationFilterComponent,
      Partial<CommissionReconciliationFilter>
    >
  >(MatDialogRef<CommissionReconciliationFilterComponent>);

  private readonly data =
    inject<Partial<CommissionReconciliationFilter>>(MAT_DIALOG_DATA);

  private readonly formBuilder = inject(NonNullableFormBuilder);

  protected readonly form: CommissionReconciliationForm;

  protected readonly processors = DEFAULT_PROCESSORS;

  protected readonly maxFileNameLength = MAX_FILE_NAME_LENGTH;

  protected readonly maxConfirmationNumberLength =
    MAX_CONFIRMATION_NUMBER_LENGTH;

  protected readonly maxAdxReferenceLength = MAX_ADX_REFERENCE_LENGTH;

  protected get showProcessorsClearIcon() {
    return !!this.form.controls.ProcessorId.value;
  }

  protected get showFileNameClearIcon() {
    return !!this.form.controls.FileName.value;
  }

  protected get showArrivalDateFromClearIcon() {
    return !!this.form.controls.ArrivalDateFrom.value;
  }

  protected get showArrivalDateToClearIcon() {
    return !!this.form.controls.ArrivalDateTo.value;
  }

  protected get showDepartureDateFromClearIcon() {
    return !!this.form.controls.DepartureDateFrom.value;
  }

  protected get showDepartureDateToClearIcon() {
    return !!this.form.controls.DepartureDateTo.value;
  }

  protected get showConfirmationNumberClearIcon() {
    return !!this.form.controls.HotelConfirmationNumber.value;
  }

  protected get showAdxReferenceClearIcon() {
    return !!this.form.controls.AdxTripReference.value;
  }

  constructor() {
    this.form = this.formBuilder.group<CommissionReconciliationFormValues>({
      ProcessorId: [],
      FileName: [],
      ArrivalDateFrom: [],
      ArrivalDateTo: [],
      DepartureDateFrom: [],
      DepartureDateTo: [],
      HotelConfirmationNumber: [],
      AdxTripReference: [],
    });
  }

  public ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    this.form.patchValue(this.data);
  }

  protected close() {
    this.data;
    this.dialogRef.close();
  }

  protected reset() {
    this.form.reset();
  }

  protected resetFilter(control: keyof CommissionReconciliationFormValues) {
    this.form.controls[control].reset();
  }

  protected alphaNumericValidator(event: KeyboardEvent) {
    const key = event.key;
    const ALLOWED_KEYS = [
      'ArrowLeft',
      'ArrowRight',
      'Backspace',
      'Delete',
      'Tab',
      'Home',
      'End',
    ];

    if (ALLOWED_KEYS.includes(key) || event.ctrlKey || event.metaKey) {
      return;
    }

    const alphanumericRegex = /^[A-Za-z0-9]+$/;
    if (alphanumericRegex.test(key) && key.length === 1) return;
    event.preventDefault();
  }

  protected apply() {
    const { ...filters } = this.form.getRawValue();
    removeEmptyParams(filters);

    const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
    if (filters.ArrivalDateFrom)
      filters.ArrivalDateFrom = moment(filters.ArrivalDateFrom).format(
        DEFAULT_DATE_FORMAT
      );

    if (filters.ArrivalDateTo)
      filters.ArrivalDateTo = moment(filters.ArrivalDateTo).format(
        DEFAULT_DATE_FORMAT
      );

    if (filters.DepartureDateFrom)
      filters.DepartureDateFrom = moment(filters.DepartureDateFrom).format(
        DEFAULT_DATE_FORMAT
      );

    if (filters.DepartureDateTo)
      filters.DepartureDateTo = moment(filters.DepartureDateTo).format(
        DEFAULT_DATE_FORMAT
      );

    this.dialogRef.close(filters);
  }
}
